import i18n from '../i18n';

/** 列表 store（createEntityStore）的提示訊息；用函式，切換語言後顯示新語言 */
export const storeMessages = {
  deleteSuccess: () => i18n.t('common.messages.deleteSuccess'),
  deleteError: () => i18n.t('common.messages.deleteFailed'),
  fetchError: () => i18n.t('common.messages.fetchFailed'),
};
